export class FormFileCaricatoVO {
  nome: string;
  hash: string = "";
  idRepository: string;
  dataInserimento: string;
  controlliPrimarioAllegati: string = "";
  controlliNomePrimarioAllegati: string = "";
  controlliAllegati: string = "";
  dimensioni: number = null;
  bozza: boolean;
}
